import React from 'react';
import PropTypes from 'prop-types';
import MinimalContentTeaser from '../Global/Teasers/MinimalContentTeaser';

const RelatedContent = ({ content }) => {
  let hasPublishedContent = false;

  const relatedContentList = (
    content.map((listItem) => {
      const { published_status, id, slug, title, plaintext_summary, thumbnail_image_url } = listItem;

      if (published_status === 'final') {
        hasPublishedContent = true;
        return (
          <li key={id} className="col-sm-6 col-lg-12">
            <MinimalContentTeaser
              href={slug}
              title={title}
              summary={plaintext_summary}
              image={thumbnail_image_url}
            />
          </li>
        );
      }
      return null;
    })
  );

  if (hasPublishedContent) {
    return (
      <div className="related-content">
        <h2 className="h2 fw-medium">Related Content</h2>

        <div className="container-fluid">
          <ul className="minimal-content-teaser-list faux-list row">
            {relatedContentList}
          </ul>
        </div>
      </div>
    );
  }
  return null;
};

RelatedContent.propTypes = {
  content: PropTypes.array,
};

export default RelatedContent;



// WEBPACK FOOTER //
// ./library/app/components/Drill/RelatedContent.js